import { render, staticRenderFns } from "./allocationStorehouseManageList.vue?vue&type=template&id=103e1fdc&scoped=true"
import script from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
export * from "./allocationStorehouseManageList.vue?vue&type=script&lang=js"
import style0 from "./allocationStorehouseManageList.vue?vue&type=style&index=0&id=103e1fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e1fdc",
  null
  
)

export default component.exports